import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetCustomers = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/customers`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load customers.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreateCustomer = async (
  formData: any,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/customers/create`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create customer.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const UpdateCustomer = async (
  payload: any,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/customers/update`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update customer.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const DeleteCustomer = async (id: string): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/customers/delete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete customer.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const ToggleCustomerStatus = async (
  id: string,
  status: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/customers/toggle-status`, {
      id,
      status,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to toggle customer status.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};
